var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplicationCompleteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 21048"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#235594"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.2583 25.6392L24.0568 23.1216H21.2583V25.6392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.6702 14.8268C16.7246 14.8813 16.7985 14.9119 16.8754 14.9119C16.9524 14.9119 17.0263 14.8813 17.0807 14.8268L19.9313 11.9761C20.0447 11.8627 20.0447 11.6789 19.9313 11.5655C19.8179 11.4521 19.6342 11.4521 19.5208 11.5655L16.8754 14.211L16.0029 13.3384C15.8895 13.225 15.7058 13.225 15.5924 13.3384C15.479 13.4518 15.479 13.6355 15.5924 13.7489L16.6702 14.8268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11 8V26H20.6776V22.8314C20.6776 22.6709 20.8076 22.5411 20.9679 22.5411H24.5217V8H11ZM17.7616 9.19219C19.9694 9.19219 21.7656 10.9883 21.7656 13.196C21.7656 15.4038 19.9694 17.2002 17.7616 17.2002C15.5539 17.2002 13.7576 15.4038 13.7576 13.196C13.7576 10.9883 15.5539 9.19219 17.7616 9.19219ZM18.4874 24.8087H13.0439C12.8836 24.8087 12.7536 24.6788 12.7536 24.5183C12.7536 24.3579 12.8836 24.228 13.0439 24.228H18.4874C18.6478 24.228 18.7778 24.3579 18.7778 24.5183C18.7778 24.6788 18.6478 24.8087 18.4874 24.8087ZM18.4874 22.9941H13.0439C12.8836 22.9941 12.7536 22.8643 12.7536 22.7038C12.7536 22.5433 12.8836 22.4135 13.0439 22.4135H18.4874C18.6478 22.4135 18.7778 22.5433 18.7778 22.7038C18.7778 22.8643 18.6478 22.9941 18.4874 22.9941ZM22.4794 21.1796H13.0439C12.8836 21.1796 12.7536 21.0498 12.7536 20.8893C12.7536 20.7288 12.8836 20.599 13.0439 20.599H22.4794C22.6397 20.599 22.7697 20.7288 22.7697 20.8893C22.7697 21.0498 22.6397 21.1796 22.4794 21.1796ZM22.4794 19.3651H13.0439C12.8836 19.3651 12.7536 19.2353 12.7536 19.0748C12.7536 18.9143 12.8836 18.7845 13.0439 18.7845H22.4794C22.6397 18.7845 22.7697 18.9143 22.7697 19.0748C22.7697 19.2353 22.6397 19.3651 22.4794 19.3651Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationCompleteLogo);
export default __webpack_public_path__ + "static/media/ApplicationCompleteLogo.485ab63580be8dc2574e64837bf78896.svg";
export { ForwardRef as ReactComponent };